import axios from 'axios';

const zones = [
  {
    name: '1A',
    temp: -60,
    color: '#D6D6FF',
  },
  {
    name: '1B',
    temp: -55,
    color: '#C4C4F2',
  },
  {
    name: '2A',
    temp: -50,
    color: '#ABABD9',
  },
  {
    name: '2B',
    temp: -45,
    color: '#EBAFEB',
  },
  {
    name: '3A',
    temp: -40,
    color: '#E091EB',
  },
  {
    name: '3B',
    temp: -35,
    color: '#D07DDB',
  },
  {
    name: '4A',
    temp: -30,
    color: '#A66BFF',
  },
  {
    name: '4B',
    temp: -25,
    color: '#5B75ED',
  },
  {
    name: '5A',
    temp: -20,
    color: '#73A1FF',
  },
  {
    name: '5B',
    temp: -15,
    color: '#5EC8E0',
  },
  {
    name: '6A',
    temp: -10,
    color: '#46BB46',
  },
  {
    name: '6B',
    temp: -5,
    color: '#77C756',
  },
  {
    name: '7A',
    temp: 0,
    color: '#ABD769',
  },
  {
    name: '7B',
    temp: 5,
    color: '#CDDC70',
  },
  {
    name: '8A',
    temp: 10,
    color: '#ECDB85',
  },
  {
    name: '8B',
    temp: 15,
    color: '#ECCA57',
  },
  {
    name: '9A',
    temp: 20,
    color: '#DBB64F',
  },
  {
    name: '9B',
    temp: 25,
    color: '#F5B678',
  },
  {
    name: '10A',
    temp: 30,
    color: '#EC9C36',
  },
  {
    name: '10B',
    temp: 35,
    color: '#E7781F',
  },
  {
    name: '11A',
    temp: 40,
    color: '#E6561E',
  },
  {
    name: '11B',
    temp: 45,
    color: '#E98564',
  },
  {
    name: '12A',
    temp: 50,
    color: '#D35A4E',
  },
  {
    name: '12B',
    temp: 55,
    color: '#B41228',
  },
  {
    name: '13A',
    temp: 60,
    color: '#95301D',
  },
  {
    name: '13B',
    temp: 65,
    color: '#741B08',
  },
];

function getZoneInfo(zone) {
  const zoneIndex = parseInt(zone, 10) - 1;
  if (zoneIndex < zones.length) {
    return zones[zoneIndex];
  }
  return null;
}

async function getZone({ latitude, longitude }) {
  const request = `https://cors-e.herokuapp.com/https://pdiimagery.azurecloudgov.us/arcgis/rest/services/PHZM_Recolor/ImageServer/identify?f=json&geometry=%7B%20%22x%22:${longitude},%20%22y%22:${latitude},%20%22spatialReference%22:%20%7B%20%22wkid%22:%204326%20%7D%20%7D&returnGeometry=true&returnCatalogItems=true&geometryType=esriGeometryPoint&pixelSize=%7B%22x%22:19,%22y%22:19,%22spatialReference%22:%7B%22wkid%22:102100%7D%7D&renderingRules=%5B%7B%22rasterFunction%22:%22Raster%20Function%20Template%20PHZM%20Recolor%22%7D%5D&returnPixelValues=false&maxItemCount=1`;
  const response = await axios.get(request);
  if (!response.data.processedValues || response.data.processedValues.length === 0) {
    return null;
  }
  const zone = getZoneInfo(response.data.processedValues[0]);

  return zone;
}

export default getZone;
